import { Filter, Product } from 'src/app/interfaces';

export class GetProductsSearch {
    static readonly type = '[Products] get all search products';
}
export class ReloadCategorySearch {
    static readonly type = '[Products] reload category search';
}

export class SearchProducts {
    static readonly type = '[Products] search products';
    constructor(public payload: string, public filters?: Filter) {}
}

export class ResetSearchPage {
    static readonly type = '[Products] reset search products';
}

export class SetListFilters {
    static readonly type = '[Products] set products list filters';
    constructor(public payload: Filter, public title: string) {}
}

export class GetBrands {
    static readonly type = '[Products] get all brands';
}

export class BrandsSearch {
    static readonly type = '[Products] search by brands';
    constructor(public payload: string) {}
}
export class GetStandardFilters {
    static readonly type = '[Products] Get bas standard filters';
}

export class AddFavoriteBrand {
    static readonly type = '[Products] Add favorite brand';
    constructor(public payload: string) {}
}

export class RemoveFavoriteBrand {
    static readonly type = '[Products] Remove favorite brand';
    constructor(public payload: string) {}
}

export class GetFavorites {
    static readonly type = '[Products] get all favorites';
}

export class UpdateAppFavorites {
    static readonly type = '[Products] Update favorites ';
    constructor(public payload: Product) {}
}
